<div *ngIf="formGroup">
  <form [formGroup]="formGroup" formFocusable>
    <!--<app-default-card
      spyTarget="deviceData"
      [title]="'Angaben zum EEG Eigenverbrauch'"
      [info]="'Bitte geben Sie hier Ihre Angaben zum EEG Eigenverbrauch an.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-grid-registration-data
        [inputForm]="formGroup"
        [meteringConcept]="feederContract.meteringConcept"
        [error]="false"></app-grid-registration-data>
    </app-default-card>-->

    <app-default-card
      [title]="'Messstellenbetreiber'"
      [info]="'Bitte wählen Sie hier den Messstellenbetreiber aus.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-meter-data [inputForm]="formGroup"></app-meter-data>
    </app-default-card>

    <app-default-card
      [title]="'Erklärung zur Registrierung'"
      [info]="'Bitte geben Sie hier die MaStR-Nummer an.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-registration-declaration-data
        [model]="feederContract"
        [producers]="feederContract.producers"
        [storages]="feederContract.storages"
        [contractType]="feederContract.contractType"
        [disableConditions]="false"
        [inputForm]="formGroup"></app-registration-declaration-data>
    </app-default-card>

    <app-default-card
      [title]="'Steuerliche Behandlung'"
      [info]="'Bitte geben Sie hier die steuerliche Behandlung an.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-tax-data [inputForm]="formGroup" [error]="false" [disableConditions]="false"></app-tax-data>
    </app-default-card>

    <app-default-card
      *ngIf="(dataShareService.tenantConfig$ | async)?.feederContract?.companyInDistressCheck"
      [title]="'Angaben zu §19 Abs. 4 EEG 2023'"
      [error]="
        (formGroup.get('companyInDistressCheck01').invalid && errorFormList.length > 0) ||
        (formGroup.get('companyInDistressCheck02').invalid && errorFormList.length > 0)
      "
      [info]="
        'Bitte geben Sie hier an, ob sich Ihr Unternehmen in Schwierigkeiten befindet. Sollte dies der Fall sein, kann Ihnen keine Einspeisevergütung ausgezahlt werden.'
      "
      [errorMessage]="
        'Ihr Unternehmen befindet sich in Schwierigkeiten oder es bestehen Rückforderungsansprüche durch Beschlüsse der Europäischen Kommission. Gemäß §19 Abs. 4 EEG 2023 kann Ihnen keine Einspeisevergütung ausgezahlt werden. - Sollte dies nicht der Fall sein, bestätigen Sie dies bitte.'
      ">
      <ng-container>
        <form-row>
          <mat-checkbox formControlName="companyInDistressCheck01">
            Ich / Wir bestätige(n) hiermit, dass mein/unser Unternehmen sich nicht in Schwierigkeiten
            befindet.
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="companyInDistressCheck02">
            Ich / Wir bestätige(n) hiermit, dass keine Rückforderungsansprüche durch Beschlüsse der
            Europäischen Kommission bestehen.
          </mat-checkbox>
        </form-row>
      </ng-container>
    </app-default-card>

    <app-default-card
      [title]="'Bankverbindung des Einspeisers'"
      [info]="'Bitte geben Sie hier die Zahlungsdaten an.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-economic-data [inputForm]="formGroup" [canUpdate]="true" [error]="false"></app-economic-data>
    </app-default-card>
  </form>
</div>
